"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deprecateClass = void 0;
var tslib_1 = require("tslib");
// eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/naming-convention
function deprecateClass(Base, msg) {
    var deprecateNoticeShown = false;
    return /** @class */ (function (_super) {
        tslib_1.__extends(class_1, _super);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        function class_1() {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var _this = this;
            if (!deprecateNoticeShown) {
                // eslint-disable-next-line no-console
                console.warn(msg);
                deprecateNoticeShown = true;
            }
            _this = _super.apply(this, tslib_1.__spread(args)) || this;
            return _this;
        }
        return class_1;
    }(Base));
}
exports.deprecateClass = deprecateClass;
//# sourceMappingURL=deprecateClass.js.map